<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { getMetaAdContext } from 'dashboard/helper/metaAdContext';

const props = defineProps({
  conversation: { type: Object, required: true },
});

const { t } = useI18n();
const context = computed(() => getMetaAdContext(props.conversation));

const channelLabel = computed(() => {
  const channel = context.value?.channel;
  if (channel === 'instagram') {
    return t('CONVERSATION.META_AD_CONTEXT.CHANNELS.INSTAGRAM');
  }
  if (channel === 'messenger') {
    return t('CONVERSATION.META_AD_CONTEXT.CHANNELS.MESSENGER');
  }
  if (channel === 'whatsapp') {
    return t('CONVERSATION.META_AD_CONTEXT.CHANNELS.WHATSAPP');
  }
  return t('CONVERSATION.META_AD_CONTEXT.CHANNELS.UNKNOWN');
});

const tooltip = computed(() =>
  context.value
    ? t('CONVERSATION.META_AD_CONTEXT.LIST_TOOLTIP', {
        channel: channelLabel.value,
      })
    : ''
);
</script>

<template>
  <span
    v-show="context"
    v-tooltip.top="tooltip"
    class="inline-flex items-center justify-center flex-shrink-0 rounded bg-n-blue-3 text-n-blue-11 size-5"
    :aria-label="tooltip"
  >
    <span class="i-lucide-megaphone size-3" />
  </span>
</template>
